import React from 'react';
import { Modal } from 'react-bootstrap'

class NotificationModal extends React.Component {

  render() {

	const { notificationModalOpen, onclose ,unsubcribe} = this.props;
	
    return (

        <Modal
            size="lg"
            centered
            onHide={onclose}
            show={notificationModalOpen}
            className="notification-modal"
            >
            <Modal.Header>
                <Modal.Title>Are you sure?</Modal.Title>
                <button
					onClick={onclose}
					type="button"
					data-dismiss="modal"
					aria-label="Close"
					className="close"
                >
                    <span className="x">x</span>
                </button>
            </Modal.Header>
            <Modal.Body>
				<p>
					You’ll be unsubscribing from all marketing emails from Askademia. This 
					includes job updates, blog articles, how Askademia works, invites and 
					referrals, surveys and research studies, Askademia course updates, 
					tutoring tips and promotions.
				</p>
            </Modal.Body>
            <Modal.Footer>
				<button
					className="cancel"
					onClick={onclose}
				>
					Cancel
				</button>
				<button
					className="unsubcribe"
					onClick={unsubcribe}
				>
					Unsubscribe
				</button>
            </Modal.Footer>
      	</Modal>
	
	);
  }
}

export default NotificationModal;